import { createRouter, createWebHistory } from 'vue-router'
import Workspace from '@/views/Workspace.vue'
import AdminLayout from '@/views/Copilot/Admin/AdminLayout.vue'

const routes = [
  {
    path: '/',
    name: 'workspace',
    component: Workspace,
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminLayout,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router